import React from 'react'
import T from 'prop-types'
import config from 'config'
import { Box, Link, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import axios from 'axios'
import { saveAs } from 'file-saver'

import useSnackbar from '../Snackbar/useSnackbar'

export default function DetailsRightBottomBar({ plate }) {
  const { t } = useTranslation()

  const { showSnackbarMessage } = useSnackbar()

  const fetchEvaluationCard = async (plate) => {
    try {
      const response = await axios.get(
        `${config.apiBaseUrl}sessions/assignment/car-evaluation/${plate}`,
        {
          headers: {
            Accept: 'application/pdf',
          },
          responseType: 'blob',
        }
      )

      saveAs(response.data, `evaluationCard-${plate}.pdf`)
    } catch (e) {
      let message = t('common.error.fetchData', {
        attribute: e.response?.status,
      })

      showSnackbarMessage({
        severity: 'error',
        message,
      })
    }
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      mt={2}
    >
      <Box />

      <Link
        component={Box}
        variant="body2"
        onClick={() => fetchEvaluationCard(plate)}
        color="textPrimary"
        sx={{ textDecoration: 'none', cursor: 'pointer' }}
      >
        <Stack direction="row" alignItems="center">
          <DescriptionOutlinedIcon />
          {t('carDetails.evaluation')}
        </Stack>
      </Link>
    </Stack>
  )
}

DetailsRightBottomBar.propTypes = {
  plate: T.string.isRequired,
}
